import * as React from 'react'
import { Phone } from 'emotion-icons/material'

import LinkButton from '../LinkButton'
import * as Styled from './PhoneCTA.styles'
import useWindowSize from '../../hooks/useWindowSize'
import determineButtonText from '../../utils/determineButtonText'

const PhoneCTA = ({
  children,
  customClasses = null,
  hidePhoneNumberOnMobile = false,
  mobileText = null,
  phoneNumber = null,
  visibility,
  ...props
}) => {
  const windowSize = useWindowSize()
  const buttonText = determineButtonText(windowSize.width, mobileText, children)
  return (
    <LinkButton
      visibility={visibility}
      className={`leshen-phone-cta ${customClasses}`}
      to={`tel:${phoneNumber}`}
      leftIcon={<Phone />}
      {...props}
    >
      {buttonText}{' '}
      <Styled.Span hidePhoneNumberOnMobile={hidePhoneNumberOnMobile}>
        {phoneNumber}
      </Styled.Span>
    </LinkButton>
  )
}

export default PhoneCTA
